export const stringToBoolean = <T extends string | null | undefined>(
  value: T,
): T extends string ? boolean : T => {
  return (
    typeof value === 'string' ? value === 'true' : value
  ) as T extends string ? boolean : T;
};

export const boolToString = (boolValue: boolean | null | undefined) => {
  if (boolValue === null || boolValue === undefined) {
    return boolValue;
  }
  return boolValue ? 'true' : 'false';
};
